export const getEsiaParams = (location) => {
  if (!location.search) return {};
  const params = new URLSearchParams(location.search);
  const esiaInfoId = params.get("esiaInfoId") || null;
  const esiaLogId = params.get("esiaLogId") || null;
  return { esiaInfoId, esiaLogId };
};
